import { roundValue, safeParseFloat } from "lib/number";
import { TOTAL_COST } from "../formulas/formula-total-cost";
import { UNITS } from "../formulas/formula-units";
import { referenceMetricValueOrCompute } from "../sibling-value-getter";
import { MetricsKind } from "../types";

export const AVERAGE_COST = ({ factoryOptions, getterParams }) => {
    const totalCost = referenceMetricValueOrCompute(
        () => {
            let totalCost = 0;
            getterParams.api.forEachNodeAfterFilter((rowNode) => {
                totalCost +=
                    TOTAL_COST({
                        factoryOptions,
                        getterParams: {
                            ...getterParams,
                            node: rowNode,
                            data: rowNode.data,
                        },
                    }) ?? 0;
            });

            return totalCost;
        },
        getterParams,
        MetricsKind.TOTAL_COST,
        undefined,
        undefined,
        factoryOptions.disableSiblingOptimization
    );

    const units = referenceMetricValueOrCompute(
        () => {
            let total = 0;
            getterParams.api.forEachNodeAfterFilter((rowNode) => {
                total +=
                    UNITS({
                        factoryOptions,
                        getterParams: {
                            ...getterParams,
                            node: rowNode,
                            data: rowNode.data,
                        },
                    }) ?? 0;
            });

            return total;
        },
        getterParams,
        MetricsKind.UNITS,
        undefined,
        undefined,
        factoryOptions.disableSiblingOptimization
    );

    const averageUnits = safeParseFloat(totalCost / units, 0);
    const roundedValue = roundValue(averageUnits, 2);
    if (roundedValue === 0) {
        return "";
    }
    return roundedValue;
};
